import { GlAvatarLabeled, GlBadge, GlIcon } from '@gitlab/ui';
import { TYPE_ISSUE, TYPE_MERGE_REQUEST } from '~/issues/constants';
import { userIsAgent, userIsDisabled, userDisabledReason } from '~/ai/agents_utils';
import { FLOW_TRIGGER_EVENTS } from '~/vue_shared/constants';
import { __ } from '~/locale';
const AVAILABILITY_STATUS = {
    NOT_SET: 'NOT_SET',
    BUSY: 'BUSY'
};
export default {
    name: 'SidebarParticipant',
    components: {
        GlAvatarLabeled,
        GlBadge,
        GlIcon
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        issuableType: {
            type: String,
            required: false,
            default: TYPE_ISSUE
        },
        selected: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        isBusy () {
            return this.user?.status?.availability === AVAILABILITY_STATUS.BUSY;
        },
        isAgent () {
            return userIsAgent(this.user);
        },
        isDisabled () {
            return userIsDisabled(this.user, FLOW_TRIGGER_EVENTS.ASSIGN);
        },
        disabledReason () {
            return userDisabledReason(this.user, FLOW_TRIGGER_EVENTS.ASSIGN);
        },
        hasCannotMergeIcon () {
            return this.issuableType === TYPE_MERGE_REQUEST && !this.user.canMerge;
        },
        subLabel () {
            return this.isDisabled ? this.disabledReason : `@${this.user.username}`;
        }
    },
    i18n: {
        busy: __('Busy'),
        agent: __('AI')
    }
};
